module.exports = __webpack_public_path__ + "img/p8-p1-text.358e2f0b.png";